/* Publish by EComposer at 2025-08-05 15:23:58*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qdycgvmv6xe"]=  window.__ectimmers["ecom-qdycgvmv6xe"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const o=e.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(t.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-qdycgvmv6xe"]["gz4rlm3dl"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let o=document.createElement("div");document.body.appendChild(o),o.click();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const s=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},n);Shopify.analytics.publish("ec_custom_events",s),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-qdycgvmv6xe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qdycgvmv6xe', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vi9amg33ja').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vi9amg33ja', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ctvrozgjss').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ctvrozgjss', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lt6xsrrrcnl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lt6xsrrrcnl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0u2z88mecd2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0u2z88mecd2', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p0obxexvqn9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p0obxexvqn9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cc2gcopse7n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cc2gcopse7n', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-j5xjro188t"]=  window.__ectimmers["ecom-j5xjro188t"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),o=e.querySelector(".text-content.ecom-html");!o||(i&&i.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-j5xjro188t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j5xjro188t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-15w1t5bb5eh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-15w1t5bb5eh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ru4dtvxideo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ru4dtvxideo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vhh6rk0yy1f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vhh6rk0yy1f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fuou85jjd06').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fuou85jjd06', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k09gl8ed66').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k09gl8ed66', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m5m5zzkiw9a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m5m5zzkiw9a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bsfzi5minxu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bsfzi5minxu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n198q1kn18').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n198q1kn18', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mfukdpgj55f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mfukdpgj55f', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-hr7puhihhb"]=  window.__ectimmers["ecom-hr7puhihhb"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=i.querySelector(".ecom-element.ecom-base-image"),s=i.closest(".core__row--columns");n&&(t(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-hr7puhihhb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hr7puhihhb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-04zr9hxt724p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-04zr9hxt724p', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h1cyhux950j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h1cyhux950j', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-fi8ikay8tl9"]=  window.__ectimmers["ecom-fi8ikay8tl9"] || {};
if(!this.$el)return;let e=this.$el;this.isLive;var i=this.id;const t=function(){const n=document.querySelectorAll(".ecom-container-lightbox-"+i);n.length&&n.forEach(function(s){const a=s.querySelector("iframe");a!=null&&(a.contentWindow.postMessage('{"method":"pause"}',"*"),a.src="");const r=s.querySelector("video");r!=null&&r.pause()})};if(e&&window.EComModal){var o=e.querySelector("[ecom-modal]");new window.EComModal(o,{cssClass:["ecom-container-lightbox-"+this.id,"ecom-html","ecom-modal","ecommodal-slide"],onOpen:function(){const n=document.querySelectorAll(".ecom-container-lightbox-"+i);n.length&&(n.forEach(function(s){const a=s.querySelector("iframe");if(a!=null){const l=a.src.replace("muted=1","muted=0").replace("mute=1","mute=0");a.src=l}const r=s.querySelector("video");r!=null&&r.play()}),window.dispatchEvent(new CustomEvent("ecom-lightbox-opened",{detail:{id:i,el:n}})))},onClose:t})}t()

                    });
                    
                        document.querySelectorAll('.ecom-fi8ikay8tl9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fi8ikay8tl9', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}